import { render, staticRenderFns } from "./ListPageShell.vue?vue&type=template&id=38bf3683&scoped=true"
import script from "./ListPageShell.vue?vue&type=script&lang=js"
export * from "./ListPageShell.vue?vue&type=script&lang=js"
import style0 from "./ListPageShell.vue?vue&type=style&index=0&id=38bf3683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf3683",
  null
  
)

export default component.exports